export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
    public detail?: unknown,
  ) {
    super(message);
  }
}

const idempotency = () => crypto.randomUUID();
const mutationIntents = new Map<string, string>();

const intentKey = (path: string, init: RequestInit) =>
  `${init.method ?? "GET"} ${path}\n${typeof init.body === "string" ? init.body : ""}`;

export async function api<T>(
  path: string,
  init: RequestInit = {},
  idempotencyKey?: string,
): Promise<T> {
  const headers = new Headers(init.headers);
  headers.set("Accept", "application/json");
  if (init.body) headers.set("Content-Type", "application/json");
  const mutating = !!init.method && !["GET", "HEAD"].includes(init.method);
  const key = mutating
    ? (idempotencyKey ??
      mutationIntents.get(intentKey(path, init)) ??
      idempotency())
    : undefined;
  if (mutating && !idempotencyKey)
    mutationIntents.set(intentKey(path, init), key!);
  if (key) headers.set("Idempotency-Key", key);
  const response = await fetch(path, {
    ...init,
    headers,
    credentials: "same-origin",
  });
  if (response.status === 401) {
    throw new ApiError(401, "Нужно войти в аккаунт");
  }
  const body = (await response.json().catch(() => undefined)) as
    { error?: string; message?: string } | undefined;
  if (!response.ok)
    throw new ApiError(
      response.status,
      body?.error ?? body?.message ?? `Ошибка API (${response.status})`,
      body,
    );
  if (mutating && !idempotencyKey)
    mutationIntents.delete(intentKey(path, init));
  return body as T;
}

export const get = <T>(path: string) => api<T>(path);
export const post = <T>(
  path: string,
  body?: unknown,
  idempotencyKey?: string,
) =>
  api<T>(
    path,
    {
      method: "POST",
      body: body === undefined ? undefined : JSON.stringify(body),
    },
    idempotencyKey,
  );
export type Role = "owner" | "member";
export type Me = {
  user: { id: string; name?: string; email?: string; displayName?: string };
  role: Role;
  vpnUser?: { id: string; name?: string; status?: string };
  permissions?: { admin: boolean };
};
